import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toggleWishlistItem } from '../../api/apiStorefront';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const useToggleWishlistItem = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: (productId) => toggleWishlistItem(productId),
    onSuccess: (data) => {


      toast.success(data?.data?.message);

      // Invalidate all wishlist-related queries
      queryClient.invalidateQueries({ queryKey: ['customer-wishlist'] });
      queryClient.invalidateQueries({ queryKey: ['wishlist-count'] });
      queryClient.invalidateQueries({ queryKey: ['wishlist-item'] });
      queryClient.invalidateQueries({ queryKey: ['home'] });
    },
    onError: (error) => {
      const message = error?.response?.data?.message || t('wishlist.toggleError', 'Failed to update wishlist');
      toast.error(message);
    },
  });
};
